import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-profile-card',
  templateUrl: './profil-card.component.html',
  styleUrls: ['./profile-cardcomponent.css'],
})
export class ProfileCardComponent {
  @Input() profileImage: string = 'assets/images/users/avatar-1.jpg';
  @Input() userName: string = 'Richard Marshall';
  @Input() isVerified: boolean = true;
  @Input() allowImageUpload: boolean = true;
  @Input() componentId: string = '1';
  @Input() imageLoading: boolean = false;

  @Output() imageChange = new EventEmitter<Event>();
  @Output() profileClick = new EventEmitter<void>();

  onFileChange(event: Event): void {
    this.imageChange.emit(event);
  }

  onProfileClick(): void {
    this.profileClick.emit();
  }

  // Handle image load errors
  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = 'assets/images/users/default-avatar.jpg'; // Fallback to default
  }
}
